import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useState } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import ErrorState from './components/ErrorState';
import Header from './components/Header';
import { RecoilRoot } from 'recoil';
import StepConfirm from './components/StepConfirm';
import StepEncodeIndex from './components/StepEncodeIndex';
import StepEncodeLetterCode from './components/StepEncodeLetterCode';
import StepWizard from 'react-step-wizard';
import useDocumentTitle from './hooks/documentTitle';
import { useTranslation } from 'react-i18next';

const queryClient = new QueryClient();
function App() {
	const { t } = useTranslation();
	useDocumentTitle({ title: t('app.title') });

	const [activeStep, setActiveStep] = useState<number>(1);
	const [steps] = useState([
		{
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='none'
					viewBox='0 0 24 24'
					strokeWidth='1.5'
					stroke='currentColor'
					className='icon'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						d='M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184'
					/>
				</svg>
			),
			text: 'encode-letter-code.title',
		},

		{
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='none'
					viewBox='0 0 24 24'
					strokeWidth='1.5'
					stroke='currentColor'
					className='icon'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						d='m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10'
					/>
				</svg>
			),
			text: 'encode-index.title',
		},
		{
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='none'
					viewBox='0 0 24 24'
					strokeWidth='1.5'
					stroke='currentColor'
					className='icon'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						d='m4.5 12.75 6 6 9-13.5'
					/>
				</svg>
			),
			text: 'confirm.title',
		},
	]);

	const title = steps[activeStep - 1].text;
	const handleStepChange = (stepChange: {
		previousStep: number;
		activeStep: number;
	}) => {
		setActiveStep(stepChange.activeStep);
	};

	return (
		<ErrorBoundary FallbackComponent={ErrorState}>
			<QueryClientProvider client={queryClient}>
				<RecoilRoot>
					<StepWizard
						initialStep={0}
						onStepChange={handleStepChange}
						nav={<Header steps={steps} activeStep={activeStep} />}
					>
						<StepEncodeLetterCode title={t(title)} />
						<StepEncodeIndex title={title} />
						<StepConfirm title={title} />
					</StepWizard>
				</RecoilRoot>
			</QueryClientProvider>
		</ErrorBoundary>
	);
}

export default App;
